import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ContentItem } from 'app/shared/services/app/content/models';

@Component({
  selector: '[togContentItem]',
  templateUrl: './content-item.component.html',
  styleUrls: ['./content-item.component.scss']
})
export class ContentItemComponent implements OnInit {
  @Input() contentItem: ContentItem;
  @Output() onEditContentItem: EventEmitter<ContentItem> = new EventEmitter<ContentItem>();
  @Output() onDeleteContentItem: EventEmitter<ContentItem> = new EventEmitter<ContentItem>();

  constructor() { }

  ngOnInit() {
  }

  getTextForHtml(html: string) {
    let div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
  }

  editContentItem() {
    this.onEditContentItem.emit(this.contentItem);
  }

  deleteContentItem() {
    this.onDeleteContentItem.emit(this.contentItem);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/content-editor/content-item/content-item.component.ts